import interact from 'interactjs';

export class InteractJSResizeEvent extends Event {
  constructor(type: string, public dimensions: { x: number; y: number }) {
    super(type, { bubbles: true });
  }
}

export const loadInteractJSPlugin = () => {
  interact('.resizable-end').resizable({
    edges: {
      top: false,
      left: false,
      bottom: false,
      right: true,
    },
    listeners: {
      move(event) {
        const target = event.target as HTMLElement;
        Object.assign(target.style, {
          width: `${event.rect.width}px`,
        });
      },
      end(event) {
        const target = event.target as HTMLElement;
        const _event = new InteractJSResizeEvent('interactjs-resize-end', {
          x: event.rect.width,
          y: event.rect.height,
        });
        target.dispatchEvent(_event);
      },
    },
  });

  interact('.resizable-top').resizable({
    edges: {
      top: true,
      left: false,
      bottom: false,
      right: false,
    },
    listeners: {
      move(event) {
        let { x, y } = event.target.dataset;
        y = (parseFloat(y) || 0) + event.deltaRect.top;
        Object.assign(event.target.style, {
          height: `${event.rect.height}px`,
          // transform: `translateY(${y}px)`,
        });
        window.dispatchEvent(new Event('below-map-resize'));
        Object.assign(event.target.dataset, { x, y });
      },
      end(event) {
        const target = event.target as HTMLElement;
        const _event = new InteractJSResizeEvent('interactjs-resize-end', {
          x: event.rect.width,
          y: event.rect.height,
        });
        target.dispatchEvent(_event);
      },
    },
  });
};
